import React from 'react';
import { Button, ButtonProps } from '@routific/hive';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import Gleap from 'gleap';

interface ContactSupportButtonProps extends ButtonProps {
  onClick?: () => void;
}

const ContactSupportButton: React.FC<ContactSupportButtonProps> = ({ onClick, ...otherProps }) => {
  const { t } = useTranslation('common');

  const handleClick = () => {
    Gleap.open();
    if (onClick) onClick();
  };


  return (
    <Button
      {...({
        ...otherProps,
        style: { paddingRight: 12, paddingLeft: 12, marginTop: 12, ...otherProps.style },
      })}
      onClick={handleClick}
    >
      {t('contactSupport.label')}
    </Button>
  );
};

export default observer(ContactSupportButton);
